import React, { Component } from 'react';

class FeatureRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Fundamentos matemáticos aplicados',
                    text: 'Dominarás conceptos clave de álgebra lineal, transformadas y estabilidad que sirven de base para el control adaptativo.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Modelado de sistemas dinámicos',
                    text: 'Aprenderás a representar sistemas en el espacio de estados, analizar su comportamiento y preparar modelos para simulación en MATLAB.'
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Diseño de control adaptativo avanzado',
                    text: 'Descubrirás cómo aplicar técnicas de control no lineal realimentado y aprendizaje en línea para afrontar sistemas con incertidumbres.'
                }
            ]            
        }
    }

    render() {
        return (
            <div className="topic-items">
                {
                    this.state.collRight.map((data,i) => (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>
                    
                    ))
            }
            </div>
        );
    }

}

export default FeatureRight;
